window.addEventListener("load", ()=> {
  const badgeButtons = document.querySelectorAll("button.product-badge-button");
  for(let button of badgeButtons){
    button.addEventListener("click", async (event) => {
      let activeInfoParagraph = document.querySelector(".badge-infos p[data-active='1']")
      let target = null;
      if(event.target.nodeName != "BUTTON"){
        target = event.target.parentElement;
      }
      else{
        target = event.target;
      }

      if(activeInfoParagraph === null){
        document.querySelector(`.badge-infos p[data-value="${target.dataset.value}"]`).dataset.active= '1';
      }
      else if(activeInfoParagraph?.dataset.value === target.dataset.value){
        activeInfoParagraph.dataset.active = '0';
      }
      else{
        activeInfoParagraph.dataset.active = '0';
        setTimeout(
          () => {document.querySelector(`.badge-infos p[data-value="${target.dataset.value}"]`).dataset.active= '1';},
          250
        );
      }
      
    });
  }
});